import ContactInfo from "./pages/contact-info/store";
import ngoService from "./services";
import NgoServices from "./pages/ngo-services/store";
import ServiceCentre from "./pages/service-centers/store";
import NgoInfo from "./pages/creation-info/store";
import BankAccounts from "./pages/bank-accounts/store";
import Branches from "./pages/branches-and-departments/store";
import mainNgoManage from "./pages/main/store";
import faqNgo from "./pages/FAQ/store";
import AuthHelpers from "@/utils/auth-helpers";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  modules: {
    BankAccounts,
    ContactInfo,
    NgoServices,
    ServiceCentre,
    NgoInfo,
    Branches,
    mainNgoManage,
    faqNgo,
  },
  state: {
    ngoData: {},
    mainNgoData: {},
    loading: false,
    changingLogo: false,
    confirmingInfo: false,
    docs: {},
    profileScore: {},
    profileScoreLoading: false,
  },
  getters: {
    ngoData(state) {
      return state.ngoData;
    },
    mainNgoData(state) {
      return state.mainNgoData;
    },
    profileScore(state) {
      return state.profileScore;
    },
    profileScoreLoading(state) {
      return state.profileScoreLoading;
    },
    loading(state) {
      return state.loading;
    },
    changingLogo(state) {
      return state.changingLogo;
    },
    docs(state) {
      return state.docs;
    },
    confirmingInfo(state) {
      return state.confirmingInfo;
    },
    canUpdateCriticalInfo(state) {
      if (state.ngoData) return state.ngoData.completed_by_ngo === null;
      else return true;
    },
    canAddTransaction(state) {
      console.log("completed_by_ministry" , state.mainNgoData.completed_by_ministry === null , state.mainNgoData.completed_by_ministry)
      if (state.mainNgoData) 
        {
          if(state.mainNgoData.completed_by_ministry === undefined){
            return true;
          }
          else{
            return state.mainNgoData.completed_by_ministry === null;
          }
        }
      else return true;
    },
  },
  mutations: {
    setNgoData(state, payload) {
      state.ngoData = payload;
    },
    setMainNgoData(state, payload) {
      state.mainNgoData = payload;
    },
    setProfileScore(state, payload) {
      state.profileScore = payload;
    },
    setChangingLogo(state, payload) {
      state.changingLogo = payload;
    },
    setProfileScoreLoading(state, payload) {
      state.profileScoreLoading = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setDocs(state, payload) {
      state.docs = payload;
    },
    setConfirmingInfo(state, payload) {
      state.confirmingInfo = payload;
    },
  },

  actions: {
    async fetchDocs({ commit }, slug) {
      try {
        const data = await ngoService.fetchDocs(slug);
        commit("setDocs", data.data);
      } catch (err) {
      } finally {
      }
    },

    async confirmInfo({ commit }, status) {
      commit("setConfirmingInfo", true);
      try {
        const res = await ngoService.confirmInfo(status);
        if (hasError(res.status)) {
          throw res.statusText;
        }
        return Promise.resolve();
      } catch (err) {
        commit("setConfirmingInfo", false);
        return Promise.reject();
      } finally {
        commit("setConfirmingInfo", false);
      }
    },
    async updateNgoLogo({ commit }, logo) {
      commit("setChangingLogo", true);
      try {
        const res = await ngoService.updateNgoLogo(logo);
        if (hasError(res.status)) {
          throw res.status;
        }
        return Promise.resolve();
      } catch (err) {
        commit("setChangingLogo", false);
        return Promise.reject(err);
      } finally {
        commit("setChangingLogo", false);
      }
    },

    async fetchMainNgoData({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ngoService.fetchMainNgoData();
        commit("setMainNgoData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchNgoData({ commit }) {
      commit("setLoading", true);
      try {
        const data = await ngoService.fetchNgoData();
        commit("setNgoData", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async refreshProfileScore({ commit }) {
      commit("setProfileScoreLoading", true);
      try {
        const res = await ngoService.refreshProfileScore();
        if (hasError(res.status)) {
          throw res.status;
        }
        commit("setProfileScore", res.data.data);
        Promise.resolve();
      } catch (err) {
        Promise.reject();
      } finally {
        commit("setProfileScoreLoading", false);
      }
    },
  },
};
